import React from 'react'
import Manager from '../../public/components/Manager'
import BonusApplicationDeatil from './BonusApplicationDeatil'
import SelectIssueDiv from './SelectIssueDiv'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        申请中: {
            buttons: [
                {
                    text: '申请...', handler: ({ showDetail, refreshPage }) =>
                        Tyan.pubForm.showDialog('奖金申请', props => <SelectIssueDiv {...props} id={0} onSave={refreshPage} showDetail={showDetail} />)
                },
            ],
            columns: [
                { _text: '奖金期号', minWidth: 250, search: true, },
                { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
                { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
                { _int: '人数', minWidth: 150, filter: true, },
                { _text: '申请原因', minWidth: 150, flex: 10, search: true },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <BonusApplicationDeatil {...props} id={data.id} />)
            }
        },
        驳回申请: {
            buttons: [
            ],
            columns: [
                { _text: '奖金期号', minWidth: 250, search: true, },
                { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
                { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
                { _int: '人数', minWidth: 150, filter: true, },
                { _text: '申请原因', minWidth: 150, flex: 10, search: true },
                { _: 'taskName', field: '_TaskName' },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <BonusApplicationDeatil {...props} id={data.id} taskName={data.taskName} />)
            }
        },
        已申请: {
            buttons: [
            ],
            columns: [
                { _text: '奖金期号', minWidth: 250, search: true, },
                { _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
                { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
                { _int: '人数', minWidth: 150, filter: true, },
                { _text: '申请原因', minWidth: 150, flex: 10, search: true },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                showDetail(props => <BonusApplicationDeatil {...props} id={data.id} />)
            }
        }
    }
}

export default props => <Manager {...props} config={config} />